import { GET_SYSTEM_STATUS, GET_SYSTEM_STATUS_SUCCESS, GET_SYSTEM_STATUS_ERROR} from './actionTypes';

export const getSystemStatus = (user) => {
    return {
        type: GET_SYSTEM_STATUS,
        payload: { user }
    }
}

export const getSystemStatusSuccess = (message, task_status) => {
    return {
        type: GET_SYSTEM_STATUS_SUCCESS,
        payload: { message, task_status}
    }
}

export const getSystemStatusError = (message) => {
    return {
        type: GET_SYSTEM_STATUS_ERROR,
        payload: message
    }
}
